import React from 'react';
import classes from "./InfoComponent.module.css";

export default function InfoComponent({data, className, showTitle, spanClass}) { 
    return (
        <div className={`${classes.infoDiv} ${className}`}>
            <div>
                <span className={`${classes.icon} ${spanClass}`}>{data?.icon}</span>
            </div>
            <div>
                {showTitle && (<p className={`f-16 fw-600 ${classes.title}`}>{data?.title}</p>)}
                <p className={`f-14 fw-500`}>{data?.content}</p>
            </div>
        </div>
    )
}
